import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import {
  selectAccounts,
  selectAccountsPagination,
  selectAccountsFilter,
  fetchAccountsActions,
  setAccountsFilterAction,
} from '../../../features/account-management/ducks';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { accountRoles } from '../../../common/enums';
import { AdministratorList } from '../components';
import { apiCallIds } from '../../../features/account-management/api';

const mapStateToProps = state => ({
  accounts: selectAccounts(state),
  pagination: selectAccountsPagination(state),
  filter: selectAccountsFilter(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_ACCOUNTS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccounts: fetchAccountsActions.request,
      setFilter: setAccountsFilterAction,
    },
    dispatch
  ),
  goTo: pathname => dispatch(push({ pathname })),
});

const defaultFilter = {
  role: [accountRoles.ADMINISTRATOR, accountRoles.OPERATOR, accountRoles.CALL_CENTRUM],
  search: '',
  registrationStatus: '',
};

@connect(mapStateToProps, mapDispatchToProps)
export default class AccountListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    goTo: PropTypes.func.isRequired,
    accounts: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.setFilter(defaultFilter);
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAccounts({
      ...this.props.filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };

  onFilterSearchChange = this.onFilterChange('search');

  onFilterRoleChange = roles => {
    if (roles.length > 0) {
      this.onFilterChange('role')(roles);
    }
  };

  onCreateNewHandler = () => {
    this.props.goTo('/admin/administrators/create');
  };

  render() {
    const { accounts, pagination, filter, isLoading } = this.props;

    return (
      <AdministratorList
        accounts={accounts}
        pagination={pagination}
        filter={filter}
        onTableChange={this.handleTableChange}
        onFilterSearchChange={this.onFilterSearchChange}
        onFilterRoleChange={this.onFilterRoleChange}
        onCreateNewHandler={this.onCreateNewHandler}
        isLoading={isLoading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/administrator-management/containers/AdministratorListContainer.js